<template>
  <v-container
    fluid
    pa-0
    fill-height
    class="align-start"
    style="max-width: 100%"
  >
    <div class="d-flex flex-column flex-grow-1 fill-height">
      <LinkDeviationCrewTable v-if="!$apollo.loading" />
    </div>
  </v-container>
</template>

<script>
import LinkDeviationCrewTable from '@/modules/linkDeviation/components/crew/LinkDeviationCrewTable'

export default {
  name: 'LinkDeviationCrew',

  components: {
    LinkDeviationCrewTable
  }
}
</script>
